import { z } from 'zod'

export const WebPageDetailsSchema = z.object({
  webPageDetails: z.object({
    name: z.string().min(1, { message: 'webPageDetails.name cannot be empty' }),
    pageViews: z.object({ value: z.string() }),
    isErrorPage: z.boolean().optional(),
  }),
})

export const WebInteractionSchema = z.object({
  webInteraction: z.object({
    name: z.string().nullable(),
    type: z.string().nullable().optional(),
    url: z.string().nullable().optional(),
    linkClicks: z.object({ value: z.string() }),
  }),
})

// Main Schema Validation
export const createADLSchemaValidation = (eventType: string) =>
  z
    .object({
      event: z.string(),
      web: eventType === 'page' ? WebPageDetailsSchema : WebInteractionSchema,
    })
    .passthrough()
